// src/pages/Home.jsx
import React from "react";
import Hero from "../components/Hero";
import AboutSection from "../components/AboutSection";
import FeaturedDishes from "../components/FeaturedDishes";

export default function Home() {
  return (
    <div className="home-page">
      <Hero />
      <AboutSection />
      <FeaturedDishes />
    </div>
  );
}
